export const AutheticationAssistant = {
    "Authentication": {
        items: [
            // How to login
            {
                heading: 'How to login',
                // permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
                tags: ['login', 'signin', 'sign', 'username', 'password'],
                sections: [
                    {
                        description: 'From the main login screen',
                        styleAs: 'list',
                        // ref: {
                        //     ref: 'ToDoListSelection',
                        //     action: 'highlight'
                        // }
                    },
                    {
                        description: 'Enter your ID Number in the User ID field',
                        styleAs: 'list',
                        ref: {
                            ref: 'LoginScreenUserID',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'and password in the password field',
                        styleAs: 'list',
                        ref: {
                            ref: 'LoginScreenPassword',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'Note: That if you would like to see the password you have entered to confirm, you can click the password visibility button next to the password field',
                        styleAs: 'note',
                        ref: {
                            ref: 'LoginScreenShowPassword',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'then click next',
                        styleAs: 'list',
                        ref: {
                            ref: 'LoginScreenNext',
                            action: 'highlight'
                        }
                    },
                ],
                options: [
                    {
                        option: 'Take me to the main login screen',
                        action: {
                            type: 'location',
                            value: '/logout',
                            // params: { section: 'main' }
                        },

                    },
                ]
            },
            // How do I recover my password
            {
                heading: 'How do I recover my password',
                // permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
                tags: ['logging in', 'forget', 'forgot', 'recover', 'password', 'reset', 'lost', 'password reset', 'reset password', 'unable to', 'cannot', 'can not'],
                sections: [
                    {
                        description: 'From the main login screen',
                        styleAs: 'list',
                        // ref: {
                        //     ref: 'ToDoListSelection',
                        //     action: 'highlight'
                        // }
                    },
                    {
                        description: 'Select the forgot password button',
                        styleAs: 'list',
                        ref: {
                            ref: 'LoginScreenForgotPassword',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'Enter your ID Number in the User ID field',
                        styleAs: 'list',
                        ref: {
                            ref: 'LoginScreenUserID',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'Click Next',
                        styleAs: 'list',
                        ref: {
                            ref: 'LoginScreenNext',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'The system will send you an email with a link to reset your password',
                        styleAs: 'note',
                        ref: {
                            ref: 'LoginScreenNext',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'Open the link in the email',
                        styleAs: 'list',
                    },
                    {
                        description: 'The system will then request you to enter a new password',
                        styleAs: 'list',
                    },
                    {
                        description: 'Click Next',
                        styleAs: 'list',
                        ref: {
                            ref: 'LoginScreenNext',
                            action: 'highlight'
                        }
                    },
                ],
                options: [
                    {
                        option: 'Take me to the main login screen',
                        action: {
                            type: 'location',
                            value: '/logout',
                            // params: { section: 'main' }
                        },

                    },
                ]
            },
            // How do I register an account
            {
                heading: 'How do I register an account',
                // permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
                tags: ['register', 'new account', 'create', 'account', 'profile'],
                sections: [
                    {
                        description: 'An account can be created by either registering on the system or by a clinical practitioner on your behalf',
                        styleAs: 'details',
                        // ref: {
                        //     ref: 'ToDoListSelection',
                        //     action: 'highlight'
                        // }
                    },
                    {
                        description: 'If you would like to register an account on the system, complete the registration form on the main login page',
                        styleAs: 'list',
                        ref: {
                            ref: 'LoginRegistrationForm',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'Your request will then be sent for approval by your closest facility',
                        styleAs: 'list',
                    },
                    {
                        description: 'If a practitioner has registered an account for you, an email will be sent to you with further details',
                        styleAs: 'note',
                        // ref: {
                        //     ref: 'ToDoListSelection',
                        //     action: 'highlight'
                        // }
                    },
                ],
                options: [
                    {
                        option: 'Take me to the main login screen',
                        action: {
                            type: 'location',
                            value: '/logout',
                            // params: { section: 'main' }
                        },

                    },
                ]
            },
            // Where can I find the terms and conditions
            {
                heading: 'Where can I find the terms and conditions',
                // permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
                tags: ['t&c', 'terms', 'terms and conditions', 'conditions', 'of use', 'policy', 'privacy', 'Ts & Cs'],
                sections: [
                    {
                        description: 'To view the terms and conditions go to the main login page',
                        styleAs: 'list',
                        ref: {
                            ref: 'LoginRegistrationForm',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'Click the DrData Ts & Cs link',
                        styleAs: 'list',
                        ref: {
                            ref: 'LoginTnCLink',
                            action: 'highlight'
                        }
                    },
                ],
                options: [
                    {
                        option: 'Take me to the main login screen',
                        action: {
                            type: 'location',
                            value: '/logout',
                            // params: { section: 'main' }
                        },

                    },
                ]
            },
            // Customising Registration form
            {
                heading: 'Customising Registration form',
                permissions: ['System Admin'],
                tags: ['registration'],
                sections: [
                    {
                        description: 'To customise the registration form go to the questionnaire builder',
                        styleAs: 'list'
                    },
                    {
                        description: 'Select the <b>System Surveys tab</b>',
                        styleAs: 'list',
                        ref: {
                            ref: 'LoginTnCLink',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'Select the <i>Login - Registration Form</i> Questionnaire',
                        styleAs: 'list',
                        ref: {
                            ref: 'LoginTnCLink',
                            action: 'highlight'
                        }
                    },
                ],
                options: [
                    {
                        option: 'Take me to the questionnaire builder',
                        action: {
                            type: 'location',
                            value: '/sys-admin/questionnaires/builder',
                            params: { section: 'main' }
                        },

                    },
                ]
            }
        ]
    }
}